import { AuthConfig } from "@auth0/auth0-angular";
import { AuthCacheService } from "@rr/shared-data-access-core";
import { UtilUrlHelper } from "@rr/shared-util";

const cId = "8w1rqmhM3PQ9cLVjF816VlXtGDDyBAgy";
const tenant = UtilUrlHelper.getTenantFromUrl();
const subDomain = tenant ? `${tenant}.` : "";
const appUrl = `https://${subDomain}forms-development.agridence.com`;

export const environment = {
  name: "development",
  production: false,
  auth0: {
    domain: "https://id-development.agridence.com",
    clientId: cId,
    authorizationParams: {
      redirect_uri: `${appUrl}/auth/callback`,
      audience: "https://forms.agridence.com",
      organization: tenant ?? "",
      scope: "openid profile email offline_access",
    },
    cache: new AuthCacheService(),
    useRefreshTokens: true,
    errorPath: `${appUrl}/error`,
  } as AuthConfig,
  appUrl: appUrl,
  firebase: {
    apiKey: "AIzaSyBNa2xEsc1zVAnVq5Q1mwRiy5aGcPTFs0E",
    authDomain: "hcplatform-development.firebaseapp.com",
    projectId: "hcplatform-development",
    storageBucket: "agd-forms-assets",
    messagingSenderId: "612736903809",
    appId: "1:612736903809:web:3de11878b244e1a64afb80",
    measurementId: "G-0535MHX8S4",
  },
  apiUrl: "https://api-forms-development.agridence.com",
  themeUrl: "https://assets.agridence.com/configs/development/{tenant}/config.json",
  postHog: {
    key: "phc_NMIi98nvCxMFry1oys6hGDagws4j623XorKRHjAHSXp",
    host: "https://us.i.posthog.com",
  },
  sentry: {
    dsn: "https://61532cee75549c1acb92e2f457b88183@o4510859648892928.ingest.de.sentry.io/4510985201975376",
    debug: false,
  },
};
